// ../components/ui/confirmModal.jsx
import React, { useEffect } from "react";
import { Button } from "./button";
import "../../sass/ui/confirmModal.scss";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  titulo,
  mensagem,

  // UI/UX
  panelClassName = "",
  panelStyle = {},
  closeOnOverlayClick = true,
  closeOnEsc = true,
  disableConfirm = false,
  loadingConfirm = false,

  // textos
  cancelText = "Cancelar",
  confirmText = "Confirmar",

  // variantes
  cancelVariant = "secondary",
  confirmVariant = "destructive",
}) => {
  // ✅ Hook SEMPRE executa (não pode ficar depois de um return condicional)
  useEffect(() => {
    if (!open) return;

    // trava scroll do body enquanto modal estiver aberto
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleKeyDown = (e) => {
      if (!closeOnEsc) return;
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = prevOverflow;
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [open, closeOnEsc, onClose]);

  // ✅ agora pode retornar
  if (!open) return null;

  const isSimpleText = !mensagem || typeof mensagem === "string";

  const handleOverlayMouseDown = () => {
    if (!closeOnOverlayClick) return;
    onClose?.();
  };

  const handleDialogMouseDown = (e) => {
    e.stopPropagation();
  };

  const handleConfirm = () => {
    if (disableConfirm || loadingConfirm) return;
    onConfirm?.();
  };

  return (
    <div className="confirm-overlay" onMouseDown={handleOverlayMouseDown}>
      <div
        className={`confirm-dialog ${panelClassName}`}
        style={panelStyle}
        onMouseDown={handleDialogMouseDown}
        role="dialog"
        aria-modal="true"
        aria-label={titulo || "Confirmar ação"}
      >
        <h2>{titulo || "Confirmar ação"}</h2>

        <div className="confirm-dialog__body">
          {isSimpleText ? (
            <p>{mensagem || "Tem certeza que deseja continuar?"}</p>
          ) : (
            mensagem
          )}
        </div>

        <div className="actions">
          <Button
            variant={cancelVariant}
            onClick={onClose}
            disabled={loadingConfirm}
          >
            {cancelText}
          </Button>

          <Button
            variant={confirmVariant}
            onClick={handleConfirm}
            disabled={disableConfirm || loadingConfirm}
          >
            {loadingConfirm ? "Processando..." : confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
